import { DvMarkerOption } from '../../../core/option';
import { FlagStyleProps } from './graphic/flag';
import { PinStyleProps } from './graphic/pin';
import { CurvedPointerStyleProps } from './graphic/curvedPointer';
import { DvMarkerAnimationCfg } from './type';

const defaultColor = 'rgba(255,36,54,0.70)';

const defaultFlagItemStyle: FlagStyleProps = {
  lineStyle: {
    type: 'line',
    style: {
      lineWidth: 2,
      lineHeight: 60,
      stroke: defaultColor
    },
    z2: 100
  },
  rectStyle: {
    type: 'rect',
    shape: {
      // width: 60,
      // height: 30,
      r: 2
    },
    style: {
      fill: defaultColor
    },
    z2: 101
  },
  circleStyle: {
    type: 'circle',
    shape: {
      cx: 0,
      cy: 0,
      r: 2.5
    },
    style: {
      fill: defaultColor,
      stroke: '#fff'
    },
    z2: 100
  },
  textStyle: {
    type: 'text',
    style: {
      x: 0,
      y: 0
    },
    z2: 101
  }
};
const defaultCurvedPointerItemStyle: CurvedPointerStyleProps = {
  lineStyle: {
    type: 'line',
    style: {
      lineWidth: 1,
      lineHeight: 60,
      stroke: defaultColor,
      fill: null
    }
  },
  rectStyle: {
    type: 'rect',
    shape: {
      // width: 60,
      // height: 30,
      r: 2
    },
    style: {
      fill: defaultColor
    }
  },
  circleStyle: {
    type: 'circle',
    shape: {
      cx: 0,
      cy: 0,
      r: 2.5
    },
    style: {
      fill: defaultColor,
      stroke: '#fff'
    },
    z2: 100
  },
  textStyle: {
    type: 'text',
    style: {
      x: 0,
      y: 0
    }
  }
};
const defaultPinItemStyle: PinStyleProps = {
  pinStyle: {
    shape: {
      width: 10,
      height: 10
    },
    style: {
      fill: '#5A5A5A'
    }
  }
};
export const defaultAnimaionOption: DvMarkerAnimationCfg = {
  enterAnimation: {
    duration: 250,
    easing: 'linear'
  },
  enterFrom: {
    style: {
      opacity: 0
    }
  },
  dvStreamAnimation: false
};

export const defaultItemStyleMap = {
  flag: defaultFlagItemStyle,
  // TODO 设置大头针标记类型的默认样式
  pin: defaultPinItemStyle,
  curvedPointer: defaultCurvedPointerItemStyle
};
export const defaultOption: DvMarkerOption = {
  type: 'dvMarker',
  dvMarkType: 'flag',
  data: [],
  dvAnimationConfig: defaultAnimaionOption,
  z: 100
};

export const defaultData = {
  markerType: 'flag',
  weight: 1
};
